export default (): void => {
  document.addEventListener("DOMContentLoaded", (): void => {
    // Create simple countdown
    document
    .querySelectorAll("[data-countdown]")
    .forEach((countdown: Element): void => {
      let all = countdown.querySelectorAll("[data-countdown-days], [data-countdown-hours], [data-countdown-minutes], [data-countdown-seconds]");
      let day = countdown.querySelector("[data-countdown-days]");
      let hrs = countdown.querySelector("[data-countdown-hours]");
      let min = countdown.querySelector("[data-countdown-minutes]");
      let sec = countdown.querySelector("[data-countdown-seconds]");

      all.forEach((el): void => {
        el.addEventListener("countdown", (e): void => {
          let element = e.target;
          let targetDaysValue = element.dataset.countdownDays;
          let targetHoursValue = element.dataset.countdownHours;
          let targetMinutesValue = element.dataset.countdownMinutes;
          let targetSecondsValue = element.dataset.countdownSeconds;
          let targetValue =
            targetDaysValue ||
            targetHoursValue ||
            targetMinutesValue ||
            targetSecondsValue ||
            0;

          //Decrement
          targetValue -= 1;

          //Loop Hours, Minutes, & Seconds
          if (targetValue < 0) {
            if ((sec && (parseInt(sec.dataset.countdownSeconds, 10) > 0 || parseInt(min.dataset.countdownMinutes, 10) > 0 || parseInt(hrs.dataset.countdownHours, 10) > 0 || parseInt(day.dataset.countdownDays, 10) > 0)) ||
                (!!targetSecondsValue && min && (parseInt(min.dataset.countdownMinutes, 10) > 0 || parseInt(hrs.dataset.countdownHours, 10) > 0 || parseInt(day.dataset.countdownDays, 10) > 0)) ||
                ((!!targetMinutesValue && hrs && (parseInt(hrs.dataset.countdownHours, 10) > 0 || parseInt(day.dataset.countdownDays, 10) > 0)) ||
                 (!!targetHoursValue && day && (parseInt(day.dataset.countdownDays, 10) > 0)))
            ) {
              if (!!targetSecondsValue) {
                min.dispatchEvent(new Event("countdown"));
              } else if (!!targetMinutesValue) {
                hrs.dispatchEvent(new Event("countdown"));
              } else if (!!targetHoursValue) {
                day.dispatchEvent(new Event("countdown"));
              }

              //Roll over Value
              targetValue = !!targetDaysValue ? 23 : 59;
            } else {
              //End countdown loop & prevent further updates
              clearInterval(parseInt(element.dataset.interval, 10));
              return;
            }
          }

          element.innerHTML = targetValue.toFixed();

          if (targetDaysValue) {
            element.dataset.countdownDays = targetValue;
          } else if (targetHoursValue) {
            element.dataset.countdownHours = targetValue;
          } else if (targetMinutesValue) {
            element.dataset.countdownMinutes = targetValue;
          } else if (targetSecondsValue) {
            element.dataset.countdownSeconds = targetValue;
          }
        });
      });

      if (!!sec) {
        sec.dataset.interval = setInterval(
          function() {
            sec.dispatchEvent(new Event("countdown"));
          },
          1000 //1 sec
        );
      } else if (!!min) {
        min.dataset.interval = setInterval(
          function() {
            min.dispatchEvent(new Event("countdown"));
          },
          60 * 1000 //60 sec * 1 sec
        );
      } else if (!!hrs) {
        hrs.dataset.interval = setInterval(
          function() {
            hrs.dispatchEvent(new Event("countdown"));
          },
          60 * 60 * 1000 //60 min * 60 Sec
        );
      } else if (!!day) {
        day.dataset.interval = setInterval(
          function() {
            day.dispatchEvent(new Event("countdown"));
          },
          24 * 60 * 60 * 1000 //24 hrs * 60 min * 60 Sec
        );
      }
    });
  });

  document.addEventListener("DOMContentLoaded", (): void => {
    const observerConfig = {
      attributes: true,
      childList: true,
      subtree: false
    };
    const observerCallback = function(mutationsList, observer) {
      updateCompleted();
    };
    const observer = new MutationObserver(observerCallback);
    let transitionPageElements;

    let targetModal: Element;
    let interruptElement: EventTarget;

    function launchModal(e: MouseEvent) {
      interruptElement = null;

      if (targetModal != null && window.$ && $.fn.modal) {
        interruptElement = e && e.target;
        $(targetModal).modal('show');
        e.preventDefault();
      }
    }

    document.querySelectorAll(".continue-action-event").forEach((continueAction: Element): void => {
      continueAction.addEventListener("click", function () {
        interruptElement.removeEventListener("click", launchModal);

        interruptElement.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));

        if (targetModal != null && window.$ && $.fn.modal) {
          $(targetModal).modal('hide');
        }
      });
    });

    function updateCompleted() {
      targetModal = null;

      let breakLoop = false;

      document.querySelectorAll(".teamstore--grid .primary").forEach((store: Element): void => {
        //Calculate total possible
        const storeTotal = store.querySelector(".completion .total");
        const items = store.querySelectorAll([
          "[data-completion-scope] > .grid-item",
          "[data-completion-scope] > .group > .row:not(.choose-one) > .grid-item > .card",
          "[data-completion-scope] > .group > .row:not(.choose-one) > .group > .row:not(.choose-one) > .grid-item",
          "[data-completion-scope] > .group > .row.choose-one",
          "[data-completion-scope] > .group > .row:not(.choose-one) > .group > .row.choose-one"
        ].join(", "));

        if (storeTotal) {
          storeTotal.innerHTML = String(items.length);
        }

        //Calculate total completed
        const completed = store.querySelector(".completion .store-complete");
        const completedTotal = store.querySelectorAll([
          ".row:not(.choose-one) > .grid-item > .complete-item",
          ".row:not(.choose-one) > .grid-item > .basket-item",
          ".row:not(.choose-one) > .grid-item > .unavailable-item",
          ".choose-one.disabled-choice",
          ".choose-one.active-choice "
        ].join(", "));

        if (completed) completed.innerHTML = String(completedTotal.length);

        const badges = store.querySelectorAll(".completion .badge");

        badges.forEach((badge: Element): void => {
          if (items.length - completedTotal.length > 0) {
            badge.classList.contains("badge-success") && badge.setAttribute("hidden","");
            badge.classList.contains("badge-secondary") && badge.removeAttribute("hidden");;
          } else {
            badge.classList.contains("badge-secondary") && badge.setAttribute("hidden","");
            badge.classList.contains("badge-success") && badge.removeAttribute("hidden");;
          }
        });

        const calculation = store.querySelector("[data-completion-scope]");
        const targetClass = calculation && calculation.dataset.completionScope;

        if (targetClass && targetClass.length > 0) {
          const targets = document.querySelectorAll(targetClass);

          targets.forEach((el: Element): void => {
            el.innerHTML = String(items.length - completedTotal.length);

            if (targetModal == null && items.length > completedTotal.length) targetModal = el.closest(".modal");
          });
        }

        if (breakLoop) return;
        else if (targetModal && items.length > completedTotal.length) {
          breakLoop = true;
        }

        document.querySelectorAll(".checkout-intermediate-blocked, .site--logo a, .site--minicart-actions a, .site--minicart-actions button, footer a")
        .forEach((el: Element): void => {
          el[items.length > completedTotal.length ? "addEventListener" : "removeEventListener"]("click", launchModal);
        });
      });
    }

    if (document.querySelector(".teamstore--grid .primary")) {
      updateCompleted();

      document.querySelectorAll(".card, .minicart-update").forEach((item: Element) => {
        observer.observe(item, observerConfig);
      });
    }
  });
};
